// @flow
import PNotify from "pnotify/dist/umd/PNotify";
import "pnotify/dist/PNotifyBrightTheme.css";

export function notify(options: {
  title: string,
  text: string,
  level: "SUCCESS" | "ERROR" | "NOTICE"
}): void {
  if (options.level === "SUCCESS") {
    PNotify.success({ ...options });
  } else {
    PNotify.error({ ...options });
  }
}
